var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirmSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 68,
    viewBox: "0 0 76 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.8,
    d: "M64.8533 21.1111L67.3867 33.7778H8.61333L11.1467 21.1111H64.8533ZM71.7778 0H4.22222V8.44444H71.7778V0ZM71.7778 12.6667H4.22222L0 33.7778V42.2222H4.22222V67.5555H46.4444V42.2222H63.3333V67.5555H71.7778V42.2222H76V33.7778L71.7778 12.6667ZM12.6667 59.1111V42.2222H38V59.1111H12.6667Z",
    fill: "#707ADB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmSmall);
export default __webpack_public_path__ + "static/media/firm_small.0b69f7416f123d51b280f00901932db3.svg";
export { ForwardRef as ReactComponent };